<template>
  <v-menu offset-y>
    <template #activator="{ on, attrs }">
      <v-btn text v-bind="attrs" v-on="on">
        <v-avatar size="22">
          <v-img
            :alt="lang"
            :src="require(`../assets/languages/${lang}.svg`)"
          />
        </v-avatar>
      </v-btn>
    </template>
    <v-list dense>
      <v-list-item
        v-for="(name, code) in languages"
        :key="code"
        @click.stop="changeLang(code)"
      >
        <v-list-item-avatar size="20">
          <v-img
            :alt="code"
            :src="require(`../assets/languages/${code}.svg`)"
          />
        </v-list-item-avatar>
        <v-list-item-title>{{ name }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'LanguagePanel',
  data() {
    return {
      lang: this.$store.getters.locale,
      languages: {
        'en': 'English',
        'ro': 'Română'
      }
    }
  },
  methods: {
    changeLang(code: string): void {
      this.$store.dispatch('setLocale', code);
      location.reload();
    }
  }
});
</script>
